export default __webpack_public_path__ + "static/port-2-3cfa30e737cef2bed6f950abbd6c0ff1.jpeg";